export default __webpack_public_path__ + "static/media/bg.e97af0a3.png";